import React, { useEffect, useRef } from "react";
import { Text, List, Checkbox, Group } from "@mantine/core";
import _ from "lodash";
import { IconAlertTriangle } from "@tabler/icons";
import { useTranslation } from "react-i18next";

const FormConfirmation = ({
  form,
  name,
  size = "xs",
  successText = ["Thank you. Please click the confirm button."],
  needCheckBox = false,
  checkBoxText = "Please confirm the above information is correct.",
  validateOnMount = false,
  fieldLabels = {},
}) => {
  const { t } = useTranslation();
  const valuesSnapshotRef = useRef();

  useEffect(() => {
    if (!validateOnMount || !form?.validate) return;

    const nextValues = form.values;
    if (
      valuesSnapshotRef.current !== undefined &&
      _.isEqual(valuesSnapshotRef.current, nextValues)
    ) {
      return;
    }

    valuesSnapshotRef.current = _.cloneDeep(nextValues);
    form.validate();
  }, [validateOnMount, form, form.values]);

  const formatError = (key, message) => {
    const label = fieldLabels[key];
    if (!label) return message;
    return `${t(label)}: ${message}`;
  };

  const showErrors = (errors) => {
    return (
      <>
        <Text size={size} mb="xl">
          {t("There are some errors. Please go back to edit.")}
        </Text>
        <List>
          {Object.keys(errors).map((key) => (
            <List.Item key={key}>
              <Text size={size}>{formatError(key, errors[key])}</Text>
            </List.Item>
          ))}
        </List>
      </>
    );
  };

  return (
    <>
      {needCheckBox && (
        <Group mb={"xl"}>
          <Checkbox />
          <Text size={"xs"}>{checkBoxText}</Text>
        </Group>
      )}
      {_.isEmpty(form.errors) && (
        <List>
          {successText?.map((txt, index) => (
            <List.Item key={index}>
              <Text size={size}>{t(txt)}</Text>
            </List.Item>
          ))}
        </List>
      )}
      {!_.isEmpty(form.errors) && (
        <Group>
          <IconAlertTriangle size={15} />
          <Text size={size}>
            {t("Please go back to check all required fields in the form.")}
          </Text>
        </Group>
      )}

      {!_.isEmpty(form.errors) && showErrors(form.errors)}
    </>
  );
};

export default FormConfirmation;
